module.exports = __webpack_public_path__ + "media/images/img-unicorn-5b5ba66d9b854fb3a3e9bc1ed623d135.svg";